import { Component } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { environment as env } from '@env/environment';

@Component({
  selector: 'app-footer',
  imports: [MatInputModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  public appVersion: string;
  scrollTop(event: Event): void {
    event.preventDefault();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  constructor() {
    this.appVersion = env.version;
  }
}
